import router from './index.js'
import store from '../store/index.js'

// 检查是否存在于免登陆白名单
function inWhiteList (toPath) {
    const whiteList = ['/login', '/']
    let result = false
    whiteList.forEach(item => {
        if (item === toPath) {
            result = true
        }
    })
    return result
}

function generateRoutes (sessionUserMenuList) {
    const userMenuList = Array.from(sessionUserMenuList)
    userMenuList.forEach(userMenu => {
        if (userMenu.routePath !== '' && userMenu.componentName !== '' &&
            userMenu.componentPath !== '') {
            var routeNode = {
                path: userMenu.routePath,
                name: userMenu.componentName,
                meta: { title: userMenu.menuName }
            }
            routeNode.component = () => import('@/views' + userMenu.componentPath + '.vue')
            router.addRoute('Home', routeNode)
        }
        if (userMenu.children.length >= 1) {
            generateRoutes(userMenu.children)
        }
    })
}

router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token')
    const menuListStr = sessionStorage.getItem('userMenuList') || '[]'
    const isAddRoutes = store.state.isAddRoutes
    if (inWhiteList(to.path)) {
        next()
    } else {
        // 用户已登录
        if (token && menuListStr !== '[]') {
            if (isAddRoutes) {
                next()
            } else {
                // 解决刷新页面空白
                const menuList = JSON.parse(menuListStr)
                store.commit('setIsAddRoutes', true)
                // 添加动态路由
                generateRoutes(menuList)
                next({ ...to, replace: true })
            }
        } else {
            store.commit('setIsAddRoutes', false)
            next('/login')
        }
    }
})
